import { render, staticRenderFns } from "./Authenticator.vue?vue&type=template&id=13d66643&"
import script from "./Authenticator.vue?vue&type=script&lang=js&"
export * from "./Authenticator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Authenticator.vue"
export default component.exports